import Vue from 'vue'
import Vuex from 'vuex'
import getters from '@/store/getters'
import app from '@/store/modules/app'
import user from '@/store/modules/user'
import cache from '@/store/modules/cache.js'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    cache
  },
  getters
})

export default store
